import getConstants from '../../constants'
import { getLanguageArg } from 'helpers/getLanguageArg'
import qs from 'qs'
import { reqError, isReqError } from '../Request/error'

export type GetStatesForRegionProps = {
  country: string
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || ''
const CONSTANTS = getConstants()

export const getAllStateList = async ({ country }: GetStatesForRegionProps) => {
  const lang = CONSTANTS.LANGUAGE
  const query = qs.stringify({
    RESET: true,
    lang: getLanguageArg(CONSTANTS.LANGUAGE),
    offset: 0,
    r: 'storelocator',
  })

  const response = await fetch(
    `${API_BASE_URL}/${country}/api/storelocator/v1/${lang}/states?${query}`,
    //{ headers: { 'x-fr-clientID': CONSTANTS.CLIENT_ID[CONSTANTS.BRAND] } },
  )
  const { status: statusCode } = response
  const json = await response.json()

  if (isReqError(statusCode)) {
    throw reqError(statusCode, json.message)
  }

  return json
}
